import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IUploadPathResponse } from '../ack-schema';
import { uploadPathResponseSchema } from '../ack-schema';

export async function uploadPersonAvatarApi(
  id: number,
  file: File,
): Promise<IValidatedResponse<IUploadPathResponse>> {
  const body = new FormData();
  body.append('file', file);
  return postRequest<IUploadPathResponse>({
    path: `/sys/people/v1/${id}/upload-avatar`,
    body,
    schema: uploadPathResponseSchema,
  });
}
